import React from 'react';

// Add CSS keyframes for confetti animation
const confettiStyles = `
  @keyframes confetti-spread {
    0% {
      transform: translate(0, 0) rotate(0deg) scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(var(--dx), var(--dy)) rotate(720deg) scale(0.5);
      opacity: 0;
    }
  }
`;

// Inject styles once
if (typeof document !== 'undefined' && !document.querySelector('#confetti-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'confetti-styles';
  styleSheet.textContent = confettiStyles;
  document.head.appendChild(styleSheet);
}

interface ConfettiAnimationProps {
  show: boolean;
  position?: { x: number; y: number };
}

const ConfettiAnimation: React.FC<ConfettiAnimationProps> = ({ show, position }) => {
  if (!show) return null;

  const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#e74c3c', '#f39c12', '#9b59b6', '#2ecc71'];

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 1000
    }}>
      {Array.from({ length: 100 }, (_, i) => {
        const angle = (Math.PI * 2 * i) / 100;
        const distance = 200 + (i % 3) * 100;
        const dx = Math.cos(angle) * distance;
        const dy = Math.sin(angle) * distance;
        
        return (
          <div
            key={i}
            style={{
              position: 'absolute',
              left: position ? `${position.x}px` : '50%',
              top: position ? `${position.y}px` : '50%',
              width: '15px',
              height: '15px',
              backgroundColor: colors[i % 10],
              borderRadius: i % 2 === 0 ? '50%' : '0',
              animation: `confetti-spread 3s ease-out forwards`,
              animationDelay: `${(i % 5) * 0.04}s`,
              '--dx': `${dx}px`,
              '--dy': `${dy}px`
            } as React.CSSProperties}
          />
        );
      })}
    </div>
  );
};

export default ConfettiAnimation;